const images = {
    locationLogo: require("../images/location_icon.png"),
    vendorLogo: require("../images/vendor_icon.png"),
    rightArrow: require("../images/right_arrow_icon.png"),
    mehendi: require("../images/mehendi.png"),
    makeup: require("../images/makeup.png"),
    photographers: require("../images/photography.png"),
    jewellery: require("../images/jewellery.png"),
    groomWear: require("../images/Groom_wear.png"),
    bridalWear: require("../images/bridal_wear.png"),
    food: require("../images/food.png"),
    florist: require("../images/florist.png"),
    musicDance: require("../images/music_dance.png"),
    venue: require("../images/venue.png"),
    decorPlan: require("../images/decor_planning.png"),
    inviteGifts: require("../images/invites_gifts.png"),
    specialOffer: require("../images/special_Offer.png"),
    process1: require("../images/process1.png"),
    process2: require("../images/process2.png"),
    process3: require("../images/process3.png"),
    process4: require("../images/process4.png"),
    logo: require("../images/wedstra_logo.png"),
    ribbon: require("../images/offer-ribbon.png"),
  };
  
  export default images;
  